/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmstools_Restore1Inputs */

const vi_cmstools_restore1 = /** @type {(inputs: Cmstools_Restore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khôi phục`)
};

/**

* @param {Cmstools_Restore1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmstools_restore1 = /** @type {((inputs?: Cmstools_Restore1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmstools_Restore1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmstools_restore1(inputs)
});
export { cmstools_restore1 as "cmsTools_restore" }